<p-dialog
    [(visible)]="visible"
    (onHide)="closeDrawer()"
    [draggable]="false"
    [resizable]="false"
    [modal]="true"
    [dismissableMask]="true"
    position="right"
    styleClass="inscriptions-modal drawer-right"
>
    <ng-template pTemplate="header">
        <h3 class="m-0">{{ 'home.widgetInfo.registration.title' | translate }}</h3>
    </ng-template>

    <div class="modal-body-content">
        <div [ngClass]="{ 'filter-active': activeFilter !== 'all' }" class="d-flex flex-wrap gap-2 mb-4">
            <p-tag
                [ngClass]="{ 'legend-tag-project-active': activeFilter === 'projects' }"
                styleClass="legend-tag"
                rounded="true"
                (click)="toggleFilter('projects')"
            >
                <div class="d-flex align-items-center gap-2">
                    <span class="legend-dot project-dot mr-2"></span>
                    <span>{{ 'home.widgetInfo.registration.project' | translate }}</span>
                </div>
            </p-tag>
            <p-tag
                [ngClass]="{ 'legend-tag-event-active': activeFilter === 'events' }"
                styleClass="legend-tag"
                rounded="true"
                (click)="toggleFilter('events')"
            >
                <div class="d-flex align-items-center gap-2">
                    <span class="legend-dot evenement-dot mr-2"></span>
                    <span>{{ 'home.widgetInfo.registration.event' | translate }}</span>
                </div>
            </p-tag>
        </div>

        <div *ngIf="isLoading" class="text-center p-5">
            <p-progressSpinner></p-progressSpinner>
        </div>

        <div class="list-container" *ngIf="!isLoading">
            <div *ngIf="showProjects && projects.length > 0">
                <div *ngFor="let project of projects; let last = last">
                    <div class="py-3 list-item-hoverable" (click)="goToProjectPage(project.id)">
                        <div class="d-flex align-items-center gap-2">
                            <span class="item-dot project-dot mr-2"></span>
                            <h6 class="fw-bold mb-0">{{ project.name }}</h6>
                        </div>

                        <div class="ms-4 ml-4">
                            <small class="text-muted d-block mt-1">
                                {{ 'home.widgetInfo.registration.from' | translate }} {{ project.startDate | date : 'dd/MM/yyyy' }}
                                {{ 'home.widgetInfo.registration.to' | translate }}
                                {{ project.endDate | date : 'dd/MM/yyyy' }}
                            </small>

                            <div *ngIf="getUserStatus(project) as status" class="mt-2">
                                <p-tag severity="info" rounded="true" [value]="status"></p-tag>
                            </div>
                        </div>
                    </div>
                    <p-divider *ngIf="!last"></p-divider>
                </div>
            </div>
            <div *ngIf="showEvents && events.length > 0">
                <p-divider *ngIf="showProjects && projects.length > 0"></p-divider>
                <div *ngFor="let event of events; let last = last">
                    <div class="py-3 list-item-hoverable" (click)="goToEventPage(event.id)">
                        <div class="d-flex align-items-center gap-2">
                            <span class="item-dot evenement-dot mr-2"></span>
                            <h6 class="fw-bold mb-0">{{ event.name }}</h6>
                        </div>

                        <div class="ms-4 ml-4">
                            <small class="text-muted d-block mt-1">
                                {{ 'home.widgetInfo.registration.from' | translate }} {{ event.startDate | date : 'dd/MM/yyyy' }}
                                {{ 'home.widgetInfo.registration.to' | translate }}
                                {{ event.endDate | date : 'dd/MM/yyyy' }}
                            </small>
                        </div>
                    </div>
                    <p-divider *ngIf="!last"></p-divider>
                </div>
            </div>
        </div>
        <div *ngIf="activeFilter === 'all' && projects.length === 0 && events.length === 0" class="text-center text-muted p-3">
            <p>{{ 'home.widgetInfo.registration.nothingRegister' | translate }}</p>
        </div>
        <div *ngIf="activeFilter === 'projects' && projects.length === 0" class="text-center text-muted p-3">
            <p>{{ 'home.widgetInfo.registration.noProjectsRegister' | translate }}</p>
        </div>
        <div *ngIf="activeFilter === 'events' && events.length === 0" class="text-center text-muted p-3">
            <p>{{ 'home.widgetInfo.registration.noEventsRegister' | translate }}</p>
        </div>
    </div>
    <p-footer>
        <div class="d-flex justify-content-between gap-3 w-100">
            <p-button
                label="{{ 'home.widgetInfo.registration.moreProjects' | translate }}"
                icon="pi pi-external-link"
                styleClass="p-button-outlined"
                (click)="goTo('projects')"
            ></p-button>
            <p-button
                label="{{ 'home.widgetInfo.registration.moreEvents' | translate }}"
                icon="pi pi-external-link"
                styleClass="p-button-outlined"
                (click)="goTo('events')"
            ></p-button>
        </div>
    </p-footer>
</p-dialog>
